import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  onAuthStateChanged,
  connectAuthEmulator,
  type User as FirebaseUser,
} from 'firebase/auth';
import {
  getFirestore,
  connectFirestoreEmulator,
  doc,
  onSnapshot,
  type DocumentSnapshot,
  type DocumentData,
} from 'firebase/firestore';
import { loading, user, resetLoadingState, type User } from './stores/user';
import { isSideBarOpen } from './stores/dropDowns';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getApp } from 'firebase/app';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyCmkRpe5aExnWszdd3Kf09UKXalUEBakTg',
  authDomain: 'menu-update-4a4d9.firebaseapp.com',
  projectId: 'menu-update-4a4d9',
  storageBucket: 'menu-update-4a4d9.appspot.com',
  messagingSenderId: '479512735418',
  appId: '1:479512735418:web:10f8c43b56b023927e1c83',
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const provider = new GoogleAuthProvider();
export const auth = getAuth();

export const db = getFirestore();

// Keep track of the firestore unsubscribe function
let firestoreUnsubscribe: (() => void) | null = null;

// Flag to track initial auth state determination
let initialAuthStateResolved = false;

// Initialize Firebase and related services
onAuthStateChanged(auth, async (fireUser: any | null) => {
  // If there's an existing firestore subscription, clean it up first
  if (firestoreUnsubscribe) {
    firestoreUnsubscribe();
    firestoreUnsubscribe = null;
  }

  if (fireUser) {
    const userRef = doc(db, 'users', fireUser.email);

    try {
      // Store the unsubscribe function so we can call it when user logs out
      firestoreUnsubscribe = onSnapshot(
        userRef,
        (snapshot: any) => {
          const data = snapshot.data();
          if (data) {
            const { sharedEmail, verified, shared, sharedId } = data;
            if (sharedEmail && sharedId) {
              user.set({
                email: fireUser.email,
                picture: fireUser.photoURL,
                name: fireUser.displayName,
                id: fireUser.uid,
                sharedEmail,
                verified,
                shared,
                sharedId,
              });
            }
          }
        },
        error => {
          console.error('Error in user document snapshot:', error);
          // Error occurred, but we still need to reset loading state
          loading.set(false);
        },
      );

      user.set({
        email: fireUser.email,
        picture: fireUser.photoURL,
        name: fireUser.displayName,
        id: fireUser.uid,
      });
      // Make sure loading state is reset even if other operations fail
      setTimeout(() => {
        loading.set(false);
      }, 500);
    } catch (error) {
      console.error('Error setting up user document listener:', error);
      // Error in setup, reset loading state
      loading.set(false);
    }
  } else {
    // Reset user store when user is null
    user.set(null);
    resetLoadingState(); // Ensure loading is reset
  }

  initialAuthStateResolved = true;

  // Ensure loading state is reset after a short delay,
  // regardless of whether user data was fetched or not.
  // This helps prevent getting stuck in a loading state.
  setTimeout(() => {
    resetLoadingState();
  }, 1500); // Adjust timeout as needed
});

export const signIn = () => signInWithPopup(auth, provider);

export const doSignOut = async () => {
  try {
    // Unsubscribe from Firestore listener if it exists
    if (firestoreUnsubscribe) {
      firestoreUnsubscribe();
      firestoreUnsubscribe = null;
    }

    // Reset user store before signing out to prevent components from trying to access it
    user.set(null);

    // Sign out from Firebase auth
    await signOut(auth);

    // Close sidebar after a short delay
    setTimeout(() => {
      isSideBarOpen.set(false);
    }, 200);
  } catch (error) {
    console.error('Error signing out:', error);
  }
};

const functions = getFunctions(getApp());

if (import.meta.env.DEV) {
  connectFunctionsEmulator(functions, 'localhost', 5001);
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFirestoreEmulator(db, 'localhost', 8080);
}
